import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from '../../utils/compose';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

const ADMIN_EMAIL = 'jeethbuildcon@gmail.com';

const withAdminAuthorization = Component => {
  class WithAdminAuthorization extends React.Component {
    componentDidMount() {
      this.listener = this.props.firebase.onAuthUserListener(
        authUser => {
          if (!authUser || authUser.email !== ADMIN_EMAIL) {
            this.props.history.push(ROUTES.ADMIN_SIGNIN);
          }
        },
        () => this.props.history.push(ROUTES.ADMIN_SIGNIN),
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {authUser =>
            authUser && authUser.email === ADMIN_EMAIL ? (
              <Component {...this.props} />
            ) : null
          }
        </AuthUserContext.Consumer>
      );
    }
  }

  return compose(
    withRouter,
    withFirebase,
  )(WithAdminAuthorization);
};

export default withAdminAuthorization;

